
import { Component, Vue, Prop } from 'vue-property-decorator';
import type { Template } from '@/shared/types/aperTemplate';
import { FieldType } from '@/shared/types/aperTemplate';

// Field Components
import TextFieldPreview from './fields/preview/TextFieldPreview.vue';
import TextareaFieldPreview from './fields/preview/TextareaFieldPreview.vue';
import NumberFieldPreview from './fields/preview/NumberFieldPreview.vue';
import DateFieldPreview from './fields/preview/DateFieldPreview.vue';
import SelectFieldPreview from './fields/preview/SelectFieldPreview.vue';
import CheckboxFieldPreview from './fields/preview/CheckboxFieldPreview.vue';
import RadioFieldPreview from './fields/preview/RadioFieldPreview.vue';
import RatingFieldPreview from './fields/preview/RatingFieldPreview.vue';
import MultiTextFieldPreview from './fields/preview/MultiTextFieldPreview.vue';
import MultiFieldPreview from './fields/preview/MultiFieldPreview.vue';
import SignatureFieldPreview from './fields/preview/SignatureFieldPreview.vue';
@Component({
  components: {
    TextFieldPreview,
    TextareaFieldPreview,
    NumberFieldPreview,
    DateFieldPreview,
    SelectFieldPreview,
    CheckboxFieldPreview,
    RadioFieldPreview,
    RatingFieldPreview,
    MultiTextFieldPreview,
    MultiFieldPreview,
    SignatureFieldPreview
  }
})
export default class TemplatePreview extends Vue {
  @Prop({ type: Object, required: true }) readonly template!: Template;

  getFieldComponent(fieldType: FieldType): string {
    const componentMap: { [key: string]: string } = {
      [FieldType.TEXT]: 'text-field-preview',
      [FieldType.TEXTAREA]: 'textarea-field-preview',
      [FieldType.NUMBER]: 'number-field-preview',
      [FieldType.DATE]: 'date-field-preview',
      [FieldType.SINGLE_SELECT]: 'select-field-preview',
      [FieldType.MULTI_SELECT]: 'select-field-preview',
      [FieldType.CHECKBOX]: 'checkbox-field-preview',
      [FieldType.RADIO]: 'radio-field-preview',
      [FieldType.RATING]: 'rating-field-preview',
      [FieldType.MULTI_TEXT]: 'multi-text-field-preview',
      [FieldType.MULTI_FIELD]: 'multi-field-preview',
      [FieldType.SIGNATURE]: 'signature-field-preview'
    };
    return componentMap[fieldType] || 'text-field-preview';
  }
}
